import React from "react";
import PropTypes from "prop-types";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const { getText } = useLanguageTranslation();

  const createPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pageNumbers.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        );
      } else {
        pageNumbers.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        );
      }
    }
    return pageNumbers;
  };

  const pageNumbers = createPageNumbers();

  return (
    <div
      className="pagination-controls"
      role="navigation"
      aria-label="Pagination"
    >
      <button
        onClick={() => {
          onPageChange(1);
        }}
        disabled={currentPage === 1}
        aria-label={getText("Go to first page", "पहले पृष्ठ पर जाएं")}
      >
        {getText("First", "पहला")}
      </button>
      <button
        onClick={() => {
          onPageChange(currentPage - 1);
        }}
        disabled={currentPage === 1}
        aria-label={getText("Go to previous page", "पिछले पृष्ठ पर जाएं")}
      >
        {getText("Previous", "पिछला")}
      </button>
      {pageNumbers.map((number, index) =>
        number === "..." ? (
          <span key={index}>...</span>
        ) : (
          <button
            key={index}
            onClick={() => {
              onPageChange(number);
            }}
            className={currentPage === number ? "active" : ""}
            aria-label={
              currentPage === number
                ? getText(
                    `Current page, page ${number}`,
                    `वर्तमान पृष्ठ, पृष्ठ ${number}`,
                  )
                : getText(`Go to page ${number}`, `पृष्ठ ${number} पर जाएं`)
            }
          >
            {number}
          </button>
        ),
      )}
      <button
        onClick={() => {
          onPageChange(currentPage + 1);
        }}
        disabled={currentPage === totalPages}
        aria-label={getText("Go to next page", "अगले पृष्ठ पर जाएं")}
      >
        {getText("Next", "अगला")}
      </button>
      <button
        onClick={() => {
          onPageChange(totalPages);
        }}
        disabled={currentPage === totalPages}
        aria-label={getText("Go to last page", "अंतिम पृष्ठ पर जाएं")}
      >
        {getText("Last", "अंतिम")}
      </button>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
